import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class GedService {
  constructor() {}

  public gedData: any = [];

  public gedDataSource = new BehaviorSubject(this.gedData);
  currentGedData = this.gedDataSource.asObservable();

  saveList(list: any) {
    this.gedDataSource.next(list);
    this.gedData = list;
  }

  saveOne(el) {
    this.gedDataSource.next([el, ...this.gedData]);
  }
}
